<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <router-view v-transition></router-view>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
export default {
  name: 'login'
}
</script>



// WEBPACK FOOTER //
// src/layouts/login.vue